import debounce from 'lodash/debounce';
import { initializeSelect2, initializeSelect2FromAjax } from './initialize-select2';

export const createDebouncedMemoRequest = (apiFn, delay = 300) => {
    const cache = new Map();

    const debounced = debounce(async (cacheKey, url, options, resolve, reject) => {
        try {
            if (cache.has(cacheKey)) {
                return resolve(cache.get(cacheKey));
            }

            const response = await apiFn(url, options);
            const data = response.data;
            cache.set(cacheKey, data);

            resolve(data);
        } catch (error) {
            reject(error);
        }
    }, delay);

    return (cacheKey, url, options) => new Promise((resolve, reject) => {
        debounced(cacheKey, url, options, resolve, reject);
    });
};

export const populateFields = (dataMap) => {
    Object.keys(dataMap).forEach((fieldName) => {
        const value = dataMap[fieldName];
        const element = $(`[name="${fieldName}"]`);
        if (element.is('select') && (fieldName.endsWith('_comune') || fieldName.endsWith('_city'))) {
            initializeSelect2FromAjax(element, value || null, value || null);
        } else if (element.is('select')) {
            initializeSelect2(element, value || null);
        } else if (element.attr('type') === 'hidden' && element.siblings('input[type="checkbox"]')) {
            let $checkbox = element.siblings('input[type="checkbox"]');
            $checkbox.prop('checked', value).trigger('change');
        } else {
            element.val(value || null);
        }
    });
};

export const clearFields = (fields) => {
    const emptyData = fields.reduce((acc, field) => {
        acc[field] = '';
        return acc;
    }, {});

    populateFields(emptyData);
};

export const propSpinner = (fields, isDisabled, spinnerClass = 'spinner') => {
    fields.forEach((field) => {
        const element = $(`[name="${field}"]`);

        if (isDisabled) {
            element.addClass(spinnerClass).prop('disabled', true);
        } else {
            element.removeClass(spinnerClass).prop('disabled', false);
        }
    });
};

export const disableSaveButton = (disable) => {
    $('[type="submit"]').prop('disabled', disable);
};
